module.exports = __webpack_public_path__ + "02_mole.4f512852.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/02_mole.png
// module id = YoaK
// module chunks = 0